import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import {
  GlobalModalRemoveComponent,
  ModalRemoveData,
} from '../../../../../../../components/global-modal-remove/global-modal-remove.component';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';

@Component({
  selector: 'app-p00045-installation-parametrage-connexion',
  templateUrl: './p00045-installation-parametrage-connexion.component.html',
  styleUrls: ['./p00045-installation-parametrage-connexion.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    TranslatePipe,
    LargedLinkComponent,
  ],
})
export class P00045InstallationParametrageConnexionComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  private modalController = inject(ModalController);

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async openModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P00045.installation.link.connexionchoice.title2',
        value: this.poolAdditionalData?.networkConnexion ?? 0,
        firstChoice: {
          title: 'P00045.installation.link.connexionchoice.option0',
          image:
            '/assets/ecosystem/images/products/P00045/P00045-connexiontype-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P00045.installation.link.connexionchoice.option1',
          image:
            '/assets/ecosystem/images/products/P00045/P00045-connexiontype-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.poolAdditionalData!.networkConnexion = data.value;
    }
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }
}
